var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Overlay = require('./Overlay.js');
var ReUpText = require('./ReUpText.js');

var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');

var {
  AppRegistry,
  View,
  TouchableOpacity,
  DeviceEventEmitter,
  StyleSheet,
  Keyboard,
  ListView,
  Text,
  Platform,
  Dimensions,
} = ReactNative;

var CustomAlertOverlay = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      isVisible : false,
      initialOpacity : 0,
      layout : {x:0,y:0,width:100,height:100}
    }
  },

  getInitialState : function()
  {
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
    var thisThing = this;
    return {
      keyboardOffset: new Animated.Value(0),
      customAlert : this.props.children,
      opacity: new Animated.Value(this.props.initialOpacity),
      isVisible: this.props.isVisible,
      didCancel: function(){ thisThing.fadeOut(); },
      disableBackgroundSelectionDismiss: false,
      hideFrame: false,
      dataSource: ds.cloneWithRows([
        'John', 'Joel', 'James', 'Jimmy', 'Jackson', 'Jillian', 'Julie', 'Devin'
      ]),
      width:-1,
      height:-1,
    }
  },

  componentDidMount : function()
  {
    if( Platform.OS !== 'web' )
    {
      if( this._keyboardWillShowSubscription ) this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', (e) => this._keyboardWillShow(e));
      if( this._keyboardWillHideSubscription ) this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', (e) => this._keyboardWillHide(e));
    }

    try {
      var {height, width} = Dimensions.get('window');

      if( height > 0 && width > 0 )
      {
        this.setState({width,height});
      }
    } catch (e) {

    } finally {

    }
  },

  componentWillUnmount : function()
  {
    if( Platform.OS !== 'web' )
    {
      if( this._keyboardWillShowSubscription ) this._keyboardWillShowSubscription.remove();
      if( this._keyboardWillHideSubscription ) this._keyboardWillHideSubscription.remove();
    }
  },

  componentWillReceiveProps : function(nextProps)
  {
    if( this.state.isVisible != nextProps.isVisible )
    {
      // this.setState({isVisible:nextProps.isVisible});
    }
  },

  _keyboardWillShow : function(e)
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.keyboardOffset,
     {toValue: e.endCoordinates.height,
     duration:100},
    ).start(function()
    {
    });
  },

  _keyboardWillHide : function(e)
  {
    var thisThing = this;
    Animated.timing(
     thisThing.state.keyboardOffset,
     {toValue: 0,
     duration:100},
    ).start(function()
    {
    });
  },

  _didFadeIn : false,
  setDidFadeIn : function(didFadeIn)
  {
    if( didFadeIn != this._didFadeIn )
    {
      if( didFadeIn ) this.fadeIn();
      else this.fadeOut();

      this._didFadeIn = didFadeIn;
    }
  },

  fadeIn : function(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss)
  {
    this._didFadeIn = true;
    var thisThing = this;
    thisThing.setState(
      {
        isVisible:true,
        customAlert: (typeof customAlert !== 'undefined') ? customAlert : this.state.customAlert,
        didCancel: (typeof didCancel !== 'undefined') ? didCancel : this.state.didCancel,
        hideFrame:hideFrame,
        disableBackgroundSelectionDismiss: typeof disableBackgroundSelectionDismiss === 'undefined' ? false : disableBackgroundSelectionDismiss,
      });
    Animated.timing(
      this.state.opacity,
      {toValue: 1, duration:200},
    ).start(function()
    {

    });
  },


  fadeOut : function()
  {
    if( !this._didFadeIn ) return;

    this._didFadeIn = false;
    var thisThing = this;
    Animated.timing(
     this.state.opacity,
     {toValue: 0,
     duration:200},
    ).start(function()
    {
      thisThing.setState({isVisible:false});
    });
  },

  render: function()
  {
    var thisThing = this;

    if( !this._didFadeIn ) return null;


    var useBlur = false;
    var containerStyle = {position:'absolute', flexDirection:'column', top:0, left:0, right:0};
    if( this.state.width > 0 && this.state.height > 0 )
    {
      containerStyle.height = this.state.height;
    }
    else
    {
      containerStyle.bottom = 0;
    }


    return (
        <View style={containerStyle}>
            <TouchableOpacity activeOpacity={0.95} style={styles.container}
              onPress={() =>
                {
                  thisThing.state.didCancel();
                  if( !thisThing.state.disableBackgroundSelectionDismiss )
                  {
                    thisThing.fadeOut();
                  } }}>
              <Animated.View style={{opacity:this.state.opacity, position:'absolute', top:0, left:0, right:0, bottom:0}}>
                {
                  useBlur ?
                    <BlurView blurType="light" style={{flex:1}}/>
                  :
                    <View style={{backgroundColor:'black', opacity:.6, flex:1}} />
                }
              </Animated.View>
            </TouchableOpacity>
            <Animated.View pointerEvents={"box-none"} style={{position:'absolute', left:0, right:0, top:0, bottom:0, paddingBottom:this.state.height > 0 ? this.state.keyboardOffset : 0, opacity:this.state.opacity}}>
              <View pointerEvents={"box-none"} style={[styles.blurStyle]}>
                {
                  this.state.hideFrame ?
                    <View pointerEvents={"box-none"} pointerEvents={"auto"} style={styles.progressMessageContainerTransparent}>
                      {this.state.customAlert}
                    </View>
                  :
                    <View pointerEvents={"box-none"} style={styles.progressMessageContainerContainer}>
                      <View pointerEvents={"auto"} style={styles.progressMessageContainer}>
                        {this.state.customAlert}
                      </View>
                    </View>
                }
              </View>
            </Animated.View>
        </View>
    )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    justifyContent: 'center',
    flexDirection:'column',
    alignItems:'stretch'
  },
  blurStyle:{
    flex:1,
    justifyContent: 'center',
    alignItems:'stretch',
    flexDirection:'column'
  },
  progressMessageContainerContainer:{
    marginVertical:10,
    justifyContent:'center',
    alignItems:'stretch',
    flex:1,
    flexBasis: 'auto'
  },
  progressMessageContainer:{
    margin:20,
    flex:-1,
    backgroundColor:'white',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#DADADA',
    flexBasis: 'auto'
  },
  progressMessageContainerTransparent:{
    margin:0,
    backgroundColor:'transparent',
    borderRadius: 0,
    borderWidth: 0,
    borderColor: 'transparent',
    flexBasis: 'auto'
  },
});

module.exports = CustomAlertOverlay;



// WEBPACK FOOTER //
// ./src/CustomAlertOverlay.js